import React from 'react'
import styles from './index.scss'
import iconSelected from './xuanzhong.png'
import iconUnSelected from './buxuanzhong.png'
import { Button } from 'antd-mobile'
import { SvgRadioSuccessIcon } from '@/libs/components/Icon/svgIcon'
import { CheckCircleFill } from 'antd-mobile-icons'

type PropsType = {
  onSelect?: () => void
  onConfirm?: () => void
  name: string
  date: string
  check?: boolean
  count: string
  unit?: string
  btnText?: string
  handleType?: 'check' | 'btn';
  color?: string;
  categoryType?: string
  containerStyles?: React.CSSProperties
}

export default function EquityCard(props: PropsType) {
  const {
    name,
    date,
    check,
    count,
    btnText,
    handleType,
    unit,
    onSelect = () => {},
    onConfirm = () => {},
  } = props

  const checkDom = check ? (
    <>
      <CheckCircleFill
        style={{ color: props?.color || 'var(--certify-primary-color)' }}
        fontSize={20}
      />
    </>
) : (
    <img src={iconUnSelected} className={styles.icon} />
  )

  return (
    <div className={styles.equityCard} onClick={onSelect} style={props?.containerStyles}>
      <div className={styles.upperPart}>
        <div className={styles.left}>
          <div className={styles.title}>{name}</div>
          <div className={styles.ogit} style={props?.color ? {  color: props?.color }:{}}>
            {count}
            {unit && <span className={styles.unit}>{unit}</span>}
          </div>
        </div>
        <div className={styles.right}>
          {handleType === 'check' && checkDom}
          {handleType === 'btn' && (
            <Button
              className={styles.btn}
              shape="rounded"
              type="submit"
              color="primary"
              size="small"
              onClick={onConfirm}
            >
              {btnText}
            </Button>
          )}
        </div>
      </div>
      <div className={styles.nextPart}>
        <div className={styles.date}> {date}</div>
      </div>
    </div>
  )
}
